<template>
  <a-breadcrumb>
    <a-breadcrumb-item
      v-for="breadcrumb in breadcrumbList"
      :key="breadcrumb.link"
    >
      <router-link
        :to="breadcrumb.link"
        v-if="breadcrumb.link"
        :style="{ fontSize: fontSize.p + 'em' }"
        >{{ breadcrumb.name }}</router-link
      >
      <!-- 沒有連結的狀態 -->
      <span v-else :style="{ fontSize: fontSize.p + 'em' }">{{
        breadcrumb.name
      }}</span>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
import { defineComponent, reactive, watch, inject } from "vue";
import { useRoute } from "vue-router";
import { apiCountry } from "@/api/api.js";

export default defineComponent({
  name: "BreadCrumb",
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    const route = useRoute();
    const countryIdList = reactive([]);
    const breadcrumbList = reactive([]);

    // 初始化麵包屑
    beginedBreadCrumbList();
    async function beginedBreadCrumbList() {
      await getcountryIdList();
      setBreadcrumbList(route.meta.breadcrumbList);

      watch(
        // 監聽route路徑，一有變更就更新麵包屑
        () => route.path,
        () => {
          setBreadcrumbList(route.meta.breadcrumbList);
        }
      );
    }

    // 取得國家編號資料
    async function getcountryIdList() {
      try {
        const res = await apiCountry().catch((err) => {
          console.log(err);
        });
        res.data.areas.forEach((area) => {
          area.countries.forEach((country) => {
            countryIdList.push(country);
          });
        });
      } catch (error) {
        console.log(error);
      }
    }

    //設定麵包屑
    function setBreadcrumbList(metaList) {
      const paramsCountryId = route.params.countryId;
      const countryId = route.query.countryId;
      let countryName;
      // 清空麵包屑
      breadcrumbList.length = 0;
      // 取得 countryId 對應之 countryName
      countryIdList.forEach((country) => {
        if (country.countryId == paramsCountryId) {
          countryName = country.countryName;
          return;
        }
        if (country.countryId == countryId) {
          countryName = country.countryName;
          return;
        }
      });

      metaList?.forEach((meta) => {
        let path = {
          ...meta,
        };
        let pushElement = true;
        // 麵包屑名稱
        if (countryName) {
          path.name = path.name.replace(
            //21個國家路徑用國家id替換
            ":countryName",
            `${countryName}`
          );
        } else {
          if (path.name === ":countryName") pushElement = false;
        }

        // 麵包屑網址
        if (path.link) {
          path.link = path.link.replace(
            //21個國家路徑用國家id替換
            "country:countryId",
            `${countryId}`
          );
        }
        if (pushElement) breadcrumbList.push(path); //path資料推進去breadcrumbList
      });
    }
    return { breadcrumbList, fontSize };
  },
});
</script>
